import {computed, defineComponent, onMounted, toRefs, watch} from 'vue';
import {useUserStore} from "@/app/stores/user-store.ts";
import {useErrorStore} from "@/app/stores/error-store.ts";
import {useGlobalHeaderStore} from "@/app/stores/global-header-store.ts";
import {useRouter} from "vue-router";
import AegLoader from '@/app/shared/components/aeg-loader/aeg-loader.vue';
import {Toast} from 'primevue';

export default defineComponent({
    name: 'app',
    components: {AegLoader, Toast},
    props: {},
    setup() {
        const userStore = useUserStore();
        const errorStore = useErrorStore();
        const globalHeaderStore = useGlobalHeaderStore();
        const {isAuthenticated, isCheckingAuthentication, isLoading, isAdmin} = toRefs(userStore);
        const router = useRouter();

        const showAdminNavigation = computed((): boolean => {
            return isAdmin.value;
        });

        const allowAnonymous = computed(() => {
            return router.currentRoute.value.meta?.allowAnonymous ?? false;
        });

        const isLoadingUserData = computed(() => {
            return isCheckingAuthentication.value || isLoading.value;
        });

        const closeAlert = (alertId: string): void => {
            errorStore.removeAlert(alertId);
        };

        onMounted(async () => {
            const headerMountElement = document.getElementsByClassName('global-header')[0] as HTMLElement;
            const footerMountElement = document.getElementsByClassName('global-footer')[0] as HTMLElement;
            if (!globalHeaderStore.isMounted) {
                // Note: do not await (no header/footer in test = will never complete)
                globalHeaderStore.setup(headerMountElement, footerMountElement).then();
            }
        });

        return {
            isAuthenticated,
            allowAnonymous,
            isLoadingUserData,
            showAdminNavigation,
            closeAlert,
        }
    }
})
